import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminAffiliateInfoComponent } from './admin-affiliate-info.component';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AdminAffiliateInfoComponent],
  exports: [AdminAffiliateInfoComponent],
  imports: [CommonModule, LoadingModule, MatSlideToggleModule, FormsModule],
})
export class AdminAffiliateInfoModule {}
